import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { api } from "../utils/api";
import PageMeta from "../components/PageMeta";

const initials = (name?: string) => (name || "?").split(" ").map(p => p[0]).join("").slice(0, 2).toUpperCase();

// navigator.contacts (Contact Picker API) n'existe quasiment que sur Android Chrome — jamais
// Safari iOS ni desktop — donc ce bouton reste masqué partout ailleurs plutôt que de mener à une
// page qui ne peut rien faire (voir InviteContacts.tsx).
const contactsPickerSupported = typeof navigator !== "undefined" && "contacts" in navigator && "ContactsManager" in window;

export default function Invite() {
  const navigate = useNavigate();
  const { user, lang } = useApp();
  const [invitees, setInvitees] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [shared, setShared] = useState(false);

  useEffect(() => {
    api.get("/users/me/invites").then(d => setInvitees(d?.invitees || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  // Même pattern que shareProfile (ProfileVisitor.tsx) : Web Share API, repli sur le
  // presse-papiers si indisponible (desktop).
  const share = async () => {
    const url = `${window.location.origin}/join?ref=${user?.referral_code}`;
    const text = "Rejoins-moi sur OLTODO, le réseau social qui reconnecte à sa ville !";
    if (navigator.share) {
      try { await navigator.share({ title: "OLTODO", text, url }); return; } catch { return; }
    }
    try {
      await navigator.clipboard.writeText(url);
      setShared(true);
      setTimeout(() => setShared(false), 2000);
    } catch {}
  };

  return (
    <div style={{ maxWidth: 480, margin: "0 auto", padding: "24px 16px" }}>
      <PageMeta title="Inviter des amis" />
      <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 6 }}>Inviter des amis</h1>
      <p style={{ fontSize: 13.5, color: "#666", marginBottom: 24, lineHeight: 1.5 }}>
        Partage ton lien, chaque ami qui rejoint OLTODO grâce à toi apparaît ci-dessous.
      </p>

      <button
        onClick={share}
        style={{ width: "100%", padding: "15px", borderRadius: 14, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 15, fontWeight: 700, cursor: "pointer", marginBottom: 12 }}
      >
        {shared ? "Lien copié !" : "Partager mon lien d'invitation"}
      </button>

      {contactsPickerSupported && (
        <button
          onClick={() => navigate("/invite-contacts")}
          style={{ width: "100%", padding: "14px", borderRadius: 14, border: "1.5px solid #E0E0E0", backgroundColor: "transparent", color: "#0a0a0a", fontSize: 14, fontWeight: 700, cursor: "pointer", marginBottom: 32 }}
        >
          {t(lang, "invite_contacts_title")}
        </button>
      )}

      <div style={{ fontSize: 13, fontWeight: 700, color: "#666", marginBottom: 12 }}>
        {loading ? "Chargement..." : invitees.length > 0 ? `${invitees.length} ami${invitees.length > 1 ? "s ont" : " a"} rejoint grâce à toi` : "Personne pour l'instant"}
      </div>

      {invitees.map(u => (
        <div key={u.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid #F0F0F0" }}>
          <div style={{ width: 40, height: 40, borderRadius: "50%", backgroundColor: "#0a0a0a", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            {u.avatar_url ? <img src={u.avatar_url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <span style={{ color: "white", fontWeight: 700, fontSize: 13 }}>{initials(u.name)}</span>}
          </div>
          <div style={{ fontSize: 14, fontWeight: 600 }}>{u.name}</div>
        </div>
      ))}
    </div>
  );
}
